import LeafRib from "./LeafRib";
import useReveal from "./useReveal";

const SectionHeading = ({ eyebrow, title, subtitle, align = "center" }) => {
  const [ref, isVisible] = useReveal();
  return (
    <div
      ref={ref}
      className={`section-heading text-${align === "center" ? "center" : "start"} ${
        isVisible ? "is-visible" : ""
      }`}
    >
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      <LeafRib />
      {subtitle && <p className="section-heading__subtitle">{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
